import { jsxs as t, jsx as i } from "react/jsx-runtime";
const e = ({
  primaryColor: h,
  secondaryColor: l,
  ...x
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "398",
    height: "240",
    viewBox: "0 0 398 240",
    ...x,
    children: [
      /* @__PURE__ */ i("rect", { x: "0.5", width: "397", height: "240", rx: "47", fill: h }),
      /* @__PURE__ */ t("g", { children: [
        /* @__PURE__ */ i("path", { d: "M 108 120 L 203 157 L 292 120 L 203 84 L 108 120 Z", fill: l }),
        /* @__PURE__ */ i("ellipse", { cx: "35", cy: "40", rx: "7.327", ry: "7.352", fill: l }),
        /* @__PURE__ */ i("ellipse", { fill: l, cx: "65", cy: "40", rx: "7.706", ry: "7.706" }),
        /* @__PURE__ */ i("ellipse", { fill: l, cx: "95", cy: "40", rx: "7.449", ry: "7.449" }),
        /* @__PURE__ */ i("path", { fill: l, d: "M 126 155 L 126 130 L 119 127 L 119 153 L 126 155 Z" }),
        /* @__PURE__ */ i("rect", { fill: l, x: "0", y: "63", width: "398", height: "7" }),
        /* @__PURE__ */ i("path", { fill: l, d: "M 105 0 L 142 65 L 152 65 L 114 0 L 105 0 Z" }),
        /* @__PURE__ */ i(
          "path",
          {
            fill: l,
            d: "M 262 140 L 203 163 L 143 140 L 143 172 C 162 203 264 191 263 169 L 262 140 Z"
          }
        ),
        /* @__PURE__ */ i("ellipse", { fill: l, cx: "122", cy: "159", rx: "6.87", ry: "6.87" })
      ] })
    ]
  }
);
export {
  e as default
};
